import PropTypes from 'prop-types';
import React from 'react';
import SearchField from '../../controls/base/SearchField/SearchField';

import FilterBar from '../../../../common/components/controls/FilterBar';
import propTypes from '../../../../common/propTypes';
import Statuses from '../../../../model/Statuses';
import translatePropTypes from '../../../translatePropTypes';
import withTranslations from '../../utils/Translations/withTranslations';

@withTranslations
export default class DynamicTreeDefaultFilter extends React.PureComponent {
  static propTypes = {
    value: PropTypes.shape({
      status: PropTypes.oneOfType([
        propTypes.status,
        PropTypes.arrayOf(propTypes.status),
      ]),
      searchQuery: PropTypes.string.isRequired,
    }).isRequired,
    onChange: PropTypes.func,
    hasSearchFieldOnly: PropTypes.bool,
    hasMultiStatus: PropTypes.bool,
    hasOmitDeleteStatus: PropTypes.bool,
    searchFieldWidthClassName: PropTypes.string,
    ...translatePropTypes,
  };

  static defaultProps = {
    hasSearchFieldOnly: false,
    onChange: null,
    hasMultiStatus: false,
    hasOmitDeleteStatus: false,
    searchFieldWidthClassName: undefined,
  };

  constructor(props) {
    super(props);

    this.state = {
      searchQuery: this.props.value.searchQuery,
    };
  }

  get searchField() {
    const { t, searchFieldWidthClassName } = this.props;
    const { searchQuery } = this.state;

    return (
      <div ref={this.handleSearchInputFocus}>
        <SearchField
          placeholder={t('Search')}
          value={searchQuery}
          widthClassName={searchFieldWidthClassName}
          onChange={this.handleSearchChange}
        />
      </div>
    );
  }

  get filterBar() {
    const { value, hasMultiStatus, hasOmitDeleteStatus } = this.props;
    const { searchQuery } = this.state;

    return (
      <FilterBar
        searchName="searchQuery"
        values={{
          status: value.status || Statuses.Active.value,
          searchQuery,
        }}
        onChange={this.handleChange}
      >
        <FilterBar.StatusSelector
          hasMultiStatus={hasMultiStatus}
          hasOmitDeleteStatus={hasOmitDeleteStatus}
          name="status"
        />
      </FilterBar>
    );
  }

  handleChange = filters => {
    const { value, onChange } = this.props;
    onChange && onChange({ ...value, ...filters });
  };

  handleSearchChange = searchQuery => {
    const { hasSearchFieldOnly } = this.props;

    this.setState({ searchQuery });

    if (hasSearchFieldOnly) {
      const { value, onChange } = this.props;
      onChange && onChange({ ...value, searchQuery });
    }
  };

  handleSearchInputFocus = searchContainerInput => {
    if (!searchContainerInput) {
      return;
    }

    const input = searchContainerInput.getElementsByTagName('input')[0];
    input && input.focus();
  };

  render() {
    const { hasSearchFieldOnly } = this.props;

    if (hasSearchFieldOnly) {
      return this.searchField;
    }

    return (
      <>
        {this.filterBar}
        {this.searchField}
      </>
    );
  }
}
